export default __webpack_public_path__ + "static/media/arrowdown.e0f48ec1.gif";